import { Outlet } from 'react-router'
import { MarqueeHeader } from '@/features/marquee/components/marquee-header'

/**
 * Layout for marquee form pages: the document body scrolls and the app header
 * stays pinned to the top (unlike the fixed-height MarqueeLayout app shell used
 * by the Virtuoso-backed list).
 */
function MarqueeFormLayout() {
	return (
		<div className='flex min-h-dvh flex-col'>
			<MarqueeHeader className='sticky top-0 z-(--z-sticky-header) shrink-0 border-neutral-200 border-b' />
			<Outlet />
		</div>
	)
}

export { MarqueeFormLayout }
